export default __webpack_public_path__ + "static/media/SS7-min.98336e51.png";